/** Hooks tRPC del panel de permisos de Learning (LEARNING_GOVERNANCE). */
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { trpc } from '@/lib/trpc';

export function useLearningGovernance() {
  return trpc.peopleLearning.governance.getGovernance.useQuery(undefined, { retry: false });
}

export function useLearningCommunityPicker() {
  return trpc.peopleLearning.governance.listCommunityForPicker.useQuery(undefined, { staleTime: 5 * 60_000, retry: false });
}

export function useSaveLearningGovernance() {
  const { t } = useTranslation();
  const utils = trpc.useUtils();
  return trpc.peopleLearning.governance.setGovernance.useMutation({
    onSuccess: () => {
      utils.peopleLearning.governance.getGovernance.invalidate();
      utils.peopleLearning.getMyAccess.invalidate();
      toast.success(t('people_learning.governance.saved', 'Permisos guardados'));
    },
    onError: (e) => toast.error(e.message),
  });
}
